import React from 'react'
import { Link } from 'react-router-dom'

export default function ModalComponent(props) {
    return (
        <div class="modal fade" id={props.modalId} tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h6 class="modal-title" style={{ textTransform: 'uppercase' }} id="largeModalLabel">{props.titulo}</h6>
                    </div>
                    <div class="modal-body">
                        <p>
                            {props.children}
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn  btn-link btn-light waves-effect m-r-10" data-dismiss="modal"> FECHAR </button>
                        {/* <Link onClick={() => { }} class="btn btn-link waves-effect bg-green text-white" > <i className='zmdi zmdi-check'></i> OK </Link> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

